import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import Button, { WrapperButton } from '../Button';
import { CustomForm, Label, Input } from '../ContactForm/style';
import { Checkbox } from '../Form';

const StyledCheckbox = styled(Checkbox)`
  text-align: left;
  margin-bottom: 40px;
  font-size: 15px;
  line-height: 21px;
  color: ${props => props.theme.color.darkGrey};
`;

class PassportFideliteForm extends PureComponent {
  state = {
    captcha: false,
    email: '',
    newsletterOptin: false
  };

  toggleChekbox() {
    const { newsletterOptin } = this.state;
    this.setState({ newsletterOptin: !newsletterOptin });
  }

  handleTextChange = (name, event) => {
    this.setState({ [name]: event.currentTarget.value });
  };

  handleSubmit = event => {
    const { email, captcha, newsletterOptin } = this.state;
    event.preventDefault();
    if (email.trim() !== '') {
      this.props.onSubmit({
        email,
        captcha,
        newsletterOptin
      });
    } else {
      this.props.onEmptyFields({ captcha });
    }
  };

  captchaResponse = response => {
    this.setState({ captcha: response });
  };

  render() {
    const { email } = this.state;
    const { info, t } = this.props;

    return (
      <CustomForm>
        <div>
          <Label>{t('common:contact.form.email.label')}</Label>
          <Input
            required
            type="email"
            id="c-mail"
            onChange={event => this.handleTextChange('email', event)}
            value={email}
            placeholder={t('common:contact.form.email.placeholder')}
          />
        </div>
        <StyledCheckbox
          name="newsletter-optin"
          onChange={() => this.toggleChekbox()}
        >
          J’accepte de recevoir la newsletter du Grand Hôtel-Dieu et ai pris
          connaissance de la politique de confidentialité.
        </StyledCheckbox>
        <div
          className="captcha"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <ReCAPTCHA
            ref="recaptcha"
            sitekey="6LfeBVIUAAAAAJoM-kVf65_NPZ4mU3fCD3BtET-8"
            onChange={this.captchaResponse}
          />
        </div>
        <WrapperButton>
          <Button href={'#'} info={info} noLink handleClick={this.handleSubmit}>
            {t('common:contact.form.button')}
          </Button>
        </WrapperButton>
      </CustomForm>
    );
  }
}

PassportFideliteForm.defaultProps = {
  info: true
};

PassportFideliteForm.propTypes = {
  subjects: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  info: PropTypes.bool
};

export default translate()(PassportFideliteForm);
